// storybook-ignore: renderar JSON-LD breadcrumb-<script> (SEO) — ingen visuell yta. Avsiktligt utan story, räkna den inte som saknad.
import * as React from 'react';
import {Breadcrumb} from 'features/template/types';

interface Props {
    breadcrumbs?: Breadcrumb[];
}

export const StructuredDataBreadcrumbs: React.FunctionComponent<Props> = ({breadcrumbs}) => {

    const structuredData = () => {

        const breadcrumbsData: { "@type": string; name: string; item: string; position: number | undefined }[] = [];
        const locationHost = window.location.protocol + '//' + window.location.hostname;

        breadcrumbs?.forEach((breadcrumb) => {
            breadcrumbsData.push(
                {
                    "@type": "ListItem",
                    "name": breadcrumb.name,
                    "item": locationHost + breadcrumb.url,
                    "position": breadcrumb.position
                }
            )
        });

        const data = {
            "@context": "http://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": breadcrumbsData
        };

        return data;
    };

    return (
        <React.Fragment>
            {breadcrumbs && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData()) }}>
            </script>}
        </React.Fragment>
    );
};


